import { useState } from 'react';
import type { PlayerMessage } from '@shared/types.js';
import { extractMapsUrl } from '@shared/geo.js';
import { pendingUrgentMessage, readUrgentSeen, writeUrgentSeen } from '../../lib/urgentMessage.js';
import { LocationButton } from './LocationButton.js';

/**
 * הודעה דחופה מהמפקדה: מוצגת בראש המסך עד שהשחקן לוחץ "הבנתי". כך הודעה דחופה לא נבלעת ביומן השדה גם אם ההתראה
 * במכשיר נסגרה, הושתקה או לא הגיעה.
 */
export function UrgentBanner({ messages }: { messages: readonly PlayerMessage[] }) {
  const [seenId, setSeenId] = useState(readUrgentSeen);
  const urgent = pendingUrgentMessage(messages, seenId, Date.now());
  if (!urgent) return null;

  const mapsUrl = extractMapsUrl(urgent.text);
  const acknowledge = () => {
    writeUrgentSeen(urgent.id);
    setSeenId(urgent.id);
  };

  return (
    <div className="urgent-banner" role="alert">
      <div className="urgent-banner__head">🚨 הודעה דחופה מהמפקדה</div>
      <div className="urgent-banner__text" dir="auto">
        {urgent.text}
      </div>
      {mapsUrl && <LocationButton url={mapsUrl} />}
      <button type="button" className="btn btn--primary btn--sm urgent-banner__ack" onClick={acknowledge}>
        הבנתי
      </button>
    </div>
  );
}
